import React, { ReactNode, useState } from "react";
import NodeTypes from "../../../../../model/workflowEditor/NodeTypes";
import { Popover } from "antd";
import Item from "../Item/Item";
import { Container } from "./Styled";
type GroupItemProps = {
  children?: ReactNode;
  Icon: ReactNode;
  nodeType: NodeTypes;
  title: string;
};

const GroupItem: React.FunctionComponent<GroupItemProps> = ({
  children,
  nodeType,
  Icon,
  title
}) => {
  const [show, setShow] = useState(false);
  const mouseOver = () => {
    if(show === false) {
        setShow(true);
    }
  };

  const mouseOut = () => {
    setShow(false);
  };

  return (
    <Container onMouseEnter={mouseOver} onMouseLeave={mouseOut}>
    <Popover visible={show} placement="left" content={children}>
        <Item Icon={Icon} title={title} nodeType={nodeType} />
    </Popover>
    </Container>
  );
};

export default GroupItem;
